import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from '../pages/Home';
import NotFound from '../pages/NotFound';
import AuthorizedRoutes from '../auth/AuthorizedRoutes';
import SearchSav from '../pages/SearchSav';
import ConsultSav from '../pages/ConsultSav';

export const APP_ROUTES = {
  home: '/',
  searchSav: '/recherche',
  error: '/erreur-service',
  unauthorized: '/acces-interdit',
};

export default function AppRouter (): React.ReactElement {
  return (
    <Routes>
      <Route path={ APP_ROUTES.home }
        element={ <Home/> }/>
      <Route element={ <AuthorizedRoutes/> }>
        <Route path={ APP_ROUTES.searchSav }
          element={ <SearchSav/> }/>
        <Route path={ `${ APP_ROUTES.searchSav }/:savNumber` }
          element={ <ConsultSav/> }/>
      </Route>
      <Route path={ APP_ROUTES.error }
        element={ <NotFound/> }/>
      <Route path="*"
        element={ <NotFound/> }/>
    </Routes>
  );
}